const styles = {
  metricsWrapper: {
    py: 1,
  },
  header: {
    color: "primary.main",
    fontSize: 12,
    pl: 2,
  },
  topPerforming: {
    color: "success.main",
    fontSize: 10,
    fontWeight: 600,
  },
};

export default styles;
